import React, { useContext, useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import Draggable from 'react-draggable';
import { useTranslation } from 'react-i18next';
import * as Styled from './styled';
import { Typography } from '@material-ui/core';
import ImmutableTimeEntry from 'api/immutables/ImmutableTimeEntry';
import { RootStoreContext } from '../../App';

interface Props {
    timeEntry: ImmutableTimeEntry;
    minLength?: number;
    maxLength?: number;
    close: () => void;
}

function BillingRulesDialog(props: Props) {
    const {
        showBillingRules,
        matterName,
        roundingInterval,
        billingLangText,
        bannedWords,
        blockBillingWords
    } = props.timeEntry;
    const rootStore = useContext(RootStoreContext);
    const { t } = useTranslation(['timeentries']);
    const { EpochConfigNarrativesMinimumChars, EpochConfigNarrativesMaximumChars, EpochConfigMatterLabel: matterLabel } = rootStore.appStore.features;
    const gloablMaxLength = EpochConfigNarrativesMaximumChars !== 999999999999999 ? EpochConfigNarrativesMaximumChars : null;
    const minNarLength = props.minLength || EpochConfigNarrativesMinimumChars;
    const maxNarLength = props.maxLength || gloablMaxLength;
    const bannedBlockBillingWords: string[] = (bannedWords || []).concat(blockBillingWords || []);
    const increment = roundingInterval / 60;

    return (!showBillingRules ? null : (
        <Draggable>
            <Styled.BillingRulesContainer>
                <Styled.BillingTitleContainer>
                    <Styled.BillingTitle>{t('form.billing_rules.title')}</Styled.BillingTitle>
                    <Styled.BiilingCloseIcon
                        fontSize="small"
                        onClick={props.close}
                    />
                </Styled.BillingTitleContainer>
                <Styled.BillingBodyContainer>
                    <Styled.BillingSubtitleContainer>
                        <Styled.BillingSubtitle variant="subtitle2">{t('form.billing_rules.label.matter', { matterLabel })}</Styled.BillingSubtitle>
                        {matterName}
                    </Styled.BillingSubtitleContainer>
                    <Styled.BillingSubtitleContainer>
                        <Styled.BillingSubtitle variant="subtitle2">{t('form.billing_rules.label.increment')}</Styled.BillingSubtitle>
                        {`${increment} minute${increment === 1 ? '' : 's'}`}
                    </Styled.BillingSubtitleContainer>
                    <Styled.BillingSubtitleContainer>
                        <Styled.BillingSubtitle variant="subtitle2">{t('form.billing_rules.label.narrative_language')}</Styled.BillingSubtitle>
                        {billingLangText}
                    </Styled.BillingSubtitleContainer>
                    <Styled.BillingSubtitleContainer>
                        <Styled.BillingSubtitle variant="subtitle2">{t('form.billing_rules.label.narrative_min_length')}</Styled.BillingSubtitle>
                        {minNarLength}
                    </Styled.BillingSubtitleContainer>
                    {maxNarLength &&
                        <Styled.BillingSubtitleContainer>
                            <Styled.BillingSubtitle variant="subtitle2">{t('form.billing_rules.label.narrative_max_length')}</Styled.BillingSubtitle>
                            {maxNarLength}
                        </Styled.BillingSubtitleContainer>
                    }
                    {bannedBlockBillingWords.length > 0 &&
                        <Styled.BillingSubtitleContainer>
                            <Typography variant="subtitle2">{t('form.billing_rules.label.bw_bbw')}</Typography>
                            <Styled.BillingBannedContainer>
                                {bannedBlockBillingWords.map((w: string, ind: number) => <Styled.BillingBannedItem key={ind}>{w}</Styled.BillingBannedItem>)}
                            </Styled.BillingBannedContainer>
                        </Styled.BillingSubtitleContainer>
                    }
                </Styled.BillingBodyContainer>
            </Styled.BillingRulesContainer>
        </Draggable>
    ));
}

export default observer(BillingRulesDialog);